import React from 'react';
import styled from '@emotion/styled';
import sizes from 'style/sizes';
import { mq } from 'style/variables';
import { ContentInner } from 'components/organisms/contentInner';

type AboutSectionProps = {
  size?: 'small';
};

export const Container = styled.div`
  padding-top: ${sizes.margin[100]};
  padding-bottom: ${sizes.margin[180]};
  ${mq.onlysp} {
    padding-top: 0;
  }
  & + & {
    margin-top: 0;
    border-top: none;
    padding-top: 0;
    ${mq.onlysp} {
    }
  }
`;

export const AboutSection: React.FC<AboutSectionProps> = props => {
  return (
    <Container {...props}>
      {props.size === 'small' ? (
        <ContentInner>{props.children}</ContentInner>
      ) : (
        <ContentInner size="large" position="right">
          {props.children}
        </ContentInner>
      )}
    </Container>
  );
};
